<div class="container-fluid">
    <div class="row">
      <div class="col-sm-9 video-screen" [ngStyle]="{'background-color': bgColor}">
        <div class="header-tab">
            <span class="dot" style="background-color: #fd38cb;"></span>
            <span class="dot" style="background-color: #f3de16;"></span>
            <span class="dot" style="background-color: #283efc;"></span>
            <audio controls autoplay style="position: absolute; width:150px; right: 0px; margin-top: 50px;">
                <source src="/assets/lobby-classic-game.mp3" type="audio/mpeg">
            </audio>
        </div>
        <div class="container">
            <div style="width: 100%;display: flex;flex-wrap: wrap; justify-content: center; padding-top: 50px;">
                <div class="video-thumbnail animate__animated animate__fadeIn" *ngFor="let video of youtubeThumbnails" [class.active]="video.url == itemclass">
                    <div (click)="selectVideoSupports(video.url)">
                        <img class="img-fluid" mat-card-image src="{{video.thumbnail.thumbnail_url}}">
                        <h4>
                            {{ video.thumbnail.author_name }}
                        </h4>
                        <h5>
                            {{ video.thumbnail.title }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="col-sm" style="padding: 20px;">
        <div class="slidecontainer">
            <h1 class="title">
                Can You Tell whether someone is a Trump or Biden supporter simply by looking at their YouTube homepage?
            </h1>
            <hr/>
            <div *ngIf="!askSelectVideo && !showDemographics">
                <h3 class="subtitle animate__animated animate__fadeIn">
                    Is it a 'Trump' or 'Biden' supporter Youtube homepage?
                </h3>
                <div class="container-btn animate__animated animate__fadeIn">
                    <button (click)="onSelect('Biden')" class="button btn-biden">BIDEN</button>
                    <button (click)="onSelect('Trump')" class="button btn-trump">TRUMP</button>
                </div>
                <!--<input type="range" min="1" max="100" value="50" class="slider" id="myRange">-->
            </div>
            <div *ngIf="askSelectVideo && !showDemographics">
                <h3 class="subtitle animate__animated animate__fadeIn">
                    Before we reveal the answer ...
                    Tap a video that suggests this is a {{candidateSelected}} supporter YouTube page.
                </h3>
            </div>
            <div *ngIf="showDemographics">
                <h3 class="subtitle animate__animated animate__fadeIn">
                    {{feedback}} this is a <strong [ngStyle]="{'color': bgColor, 'text-weight': '700'}">{{youtube[this.position].demographics.candidate}}</strong> supporter YouTube home page.
                </h3>
                <div class="user-card">
                    <h4>A little bit about the user:</h4>
                    <h5 calss="demographics">
                        <strong>Pronouns: </strong>{{youtube[position].demographics['pronouns']}}, 
                        <strong>residency: </strong>{{youtube[position].demographics['geo']}}, 
                        <strong>race or ethincity: </strong>{{youtube[position].demographics['race']}}, 
                        <strong>age: </strong>{{youtube[position].demographics['age']}}.
                    </h5>
                </div>
                
                <div class="container-btn animate__animated animate__fadeIn">
                    <button (click)="next()" class="button btn-next">NEXT</button>
                </div>
            </div>
          </div>
      </div>
    </div>
</div>
<div class="counter">
    <span>
        You got <span class="bg-yellow">{{correctCounter}}</span> answers correct 
        out of <span class="bg-yellow">{{answersCounter}}</span>
        <span *ngIf="currentScore;else else_content">,<br />
            for a score of <span class="bg-yellow">{{currentScore}}%</span>.
        </span>
        <ng-template #else_content>.</ng-template>
    </span>
    <br /><br />
    <span>
        So far <span class="bg-yellow">{{allUsersCounter}}</span> users have made 
        <span class="bg-yellow">{{allAnswersCounter}}</span> guesses<br />
        (<span class="bg-yellow">{{averageScore}}</span>% of them were correct).<br />
        <br />
        <a href="javascript:void()">See more stats</a>

    </span>
</div>
